import { Flex } from "@mantine/core";
import React from "react";
import { Link } from "react-router-dom";

import styles from "./Breadcrumbs.module.scss";

interface IBreadcrumbContainer extends React.HTMLAttributes<HTMLDivElement> {
  border?: boolean;
  pb?: number;
}

export const BreadcrumbContainer: React.FC<IBreadcrumbContainer> = ({
  border,
  pb,
  children,
  className,
  style,
  ...rest
}) => (
  <Flex
    className={`${styles.breadcrumbContainer} ${border ? styles.withBorder : ""} ${className ?? ""}`}
    style={{ ...(style || {}), ...(pb ? { paddingBottom: `${pb}px` } : {}) }}
    {...(rest as any)}>
    {children}
  </Flex>
);

export const BreadcrumbLink: React.FC<React.ComponentProps<typeof Link>> = ({
  children,
  className,
  ...rest
}) => (
  <Link className={`${styles.breadcrumbLink} ${className ?? ""}`} {...rest}>
    {children}
  </Link>
);
